<template>
  <v-data-table :headers="presentationHeaders" :items="presentations" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-row align="center">
          <v-col class="text-subtitle-2 gray--text text--lighten-1">
            Apresentações
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on" @click:outside="close">
                  Nova apresentação
                </v-btn>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="12">
                        <v-select
                          outlined
                          dense
                          hide-details
                          v-model="editedItem"
                          :items="medicinePresentations"
                          item-text="name"
                          label="Nome"
                          return-object
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_medicine"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há dados cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "PresentationTable",
    props: {
      applicationRoute: Object,
      refreshList: Function,
    },
    data() {
      return {
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        presentationHeaders: [
          { text: "Nome", value: "name" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
      };
    },
    apollo: {
      medicinePresentations: {
        query: require("@/graphql/medicine/medicine_presentations.gql"),
        update(data) {
          return data.medicinePresentations;
        },
      },
    },
    computed: {
      presentations() {
        return this.applicationRoute.presentations;
      },
      formTitle() {
        return this.editedIndex === -1 ? "Nova apresentação" : "Editar apresentação";
      },
      orderedPresentations(){
        if(!this.medicinePresentations) return;
      return this.lodash.orderBy(this.medicinePresentations, ["name"], ["asc"]);
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.presentations.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/medicine/unlink_application_route_and_presentation.gql"),
            variables: {
              presentationId: item.id,
              applicationRouteId: this.applicationRoute.id,
            },
          }).then(() => {
            this.refreshList();

            this.$store.dispatch("createNotification", {
              message: "Cadastro salvo com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/medicine/link_application_route_and_presentation.gql"),
          variables: {
            presentationId: this.editedItem.id,
            applicationRouteId: this.applicationRoute.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
